<template>
  <FormItem :label="model.variable.label" :inline="inline">
    <CheckboxGroup v-model="newVal" @on-change="changeVal">
      <Checkbox v-for="(code, key) in model.variable.codes" :key="key"
       :label="'' + key">
        {{ code }}
      </Checkbox>
    </CheckboxGroup>
  </FormItem>
</template>

<script>
export default {
  name: 'radio-element',
  data: function () {
    return {
      newVal: this.model.val ? this.model.val.split(',') : []
    }
  },
  // watch: {
  //   'val': function () {
  //     this.newVal = this.model.val ? this.model.val.split(',') : []
  //   }
  // },
  props: ['model', 'inline'],
  methods: {
    changeVal: function (value) {
      let val = null
      if (value.length > 0) {
        val = value.pop()
        this.newVal = [val]
      } else {
        this.newVal = []
      }
      this.model.val = this.newVal.join(',')
      // this.$emit('editVal', this.model, val)
    }
  }
}
</script>
